import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getItemsFromObject } from "../services/array/transformObject";
import { propertiesRoutes } from "../app/routes";
import { useEffect, useState } from "react";

export const useBrowserTabTitle = (rootPath: string = "") => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const routeTitle = [...getItemsFromObject(propertiesRoutes)].find(
    (f) => f.path === pathname
  )?.title;
  const [tabTitle, setTabTitle] = useState("");

  useEffect(() => {
    let title = "";
    if (rootPath && rootPath == pathname) {
      title = `${routeTitle}`;
    } else {
      title = `${t("property.title")}-${routeTitle}`;
    }
    setTabTitle(title);
    document.title = title;
  }, [routeTitle, t, pathname, rootPath]);

  return [tabTitle] as const;
};
